document.addEventListener('DOMContentLoaded', function () {
    const parallaxElement = document.querySelector('.ccm-block-hero-image-image-parallax');
    if (parallaxElement) {

        const parallaxElement = document.querySelector('.ccm-block-hero-image-image-parallax');
        if (parallaxElement) {
            const elementTop = parallaxElement.getBoundingClientRect().top + window.scrollY;
            const viewportHeight = window.innerHeight;

            document.addEventListener('scroll', function () {
                const scrolled = window.scrollY !== undefined ? window.scrollY : document.documentElement.scrollTop;

                const elementInView = (scrolled + viewportHeight) > elementTop && scrolled < (elementTop + parallaxElement.offsetHeight);
                if (elementInView) {
                    const distanceFromViewportTop = viewportHeight + scrolled - elementTop;
                    const elementHeight = parallaxElement.offsetHeight + viewportHeight;
                    const percentageScrolled = distanceFromViewportTop / elementHeight;
                    const backgroundPositionY = percentageScrolled * 130; // this value should match the size in the _view.scss file

                    parallaxElement.style.backgroundPositionY = `${backgroundPositionY}%`;
                }
            });
        }
    }
});


/**
 * Trigger the scroll event once the window has fully loaded as if the user has their viewport scrolled to the very
 * end of the window and refresh the page, the parallax image does not refresh correctly and is set to its initial
 * state which shows a repeating image
 */

window.addEventListener('load', function () {
    const parallaxElement = document.querySelector('.ccm-block-hero-image-image-parallax');
    if (parallaxElement) {

        const parallaxElement = document.querySelector('.ccm-block-hero-image-image-parallax');
        if (parallaxElement) {
            parallaxElement.style.backgroundImage = `url(${parallaxElement.dataset.bgImageParallax})`;
            parallaxElement.style.opacity = '1'; // Fade in after the element is loaded
        }
    }
    
    const event = new Event('scroll');
    document.dispatchEvent(event);
});